import { useEffect, useState } from "react";
import API from "../services/api";
import MainLayout from "../layouts/MainLayout";

export default function AssignSalesman() {
  const [salesmen, setSalesmen] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [selectedSalesman, setSelectedSalesman] = useState("");
  const [selectedDealer, setSelectedDealer] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // 🔥 You should create /users API later
      const usersRes = await API.get("/users"); // filter on frontend
      const dealersRes = await API.get("/dealer");

      setSalesmen(usersRes.data.filter(u => u.role === "salesman"));
      setDealers(dealersRes.data);

    } catch (err) {
      console.log("Load error");
    }
  };

  const assign = async () => {
    if (!selectedSalesman || !selectedDealer) {
      return alert("Select both fields");
    }

    try {
      await API.post("/admin/assign-salesman", {
        salesman_id: selectedSalesman,
        dealer_id: selectedDealer
      });

      alert("✅ Salesman assigned successfully");

    } catch (err) {
      alert("❌ Assignment failed");
    }
  };

  return (
    <MainLayout>
      <h2>Assign Salesman to Dealer</h2>

      {/* SALES MAN */}
      <div style={{ marginBottom: 20 }}>
        <label>Salesman</label>
        <select onChange={(e) => setSelectedSalesman(e.target.value)}>
          <option>Select Salesman</option>
          {salesmen.map(s => (
            <option key={s.id} value={s.id}>
              {s.name} ({s.mobile})
            </option>
          ))}
        </select>
      </div>

      {/* DEALER */}
      <div style={{ marginBottom: 20 }}>
        <label>Dealer</label>
        <select onChange={(e) => setSelectedDealer(e.target.value)}>
          <option>Select Dealer</option>
          {dealers.map(d => (
            <option key={d.id} value={d.id}>
              {d.dealer_name}
            </option>
          ))}
        </select>
      </div>

      {/* BUTTON */}
      <button onClick={assign}>Assign</button>
    </MainLayout>
  );
}